import { VpnKey } from '@material-ui/icons';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { RoutesPaths } from 'constants/routesPath';
import React from 'react';

const LandingPage = React.lazy(() =>
  import('pages/App/LandingPage/LandingPage'),
);
const Register = React.lazy(() => import('pages/Register/Register'));

const NotFoundPage = React.lazy(() => import('pages/NotFoundPage'));
const ContactUsPage = React.lazy(() => import('pages/Register/Register'));

const TermsAndConditionsPage = React.lazy(() =>
  import('pages/App/TermsAndConditions/TermsAndConditionsPage'),
);
const AboutPage = React.lazy(() => import('pages/App/about/AboutPage'));

const ForgetPassword = React.lazy(() => import('pages/ForgetPassword'));
const ResetPassword = React.lazy(() => import('pages/ResetPassword'));

const ChangePasswordPage = React.lazy(() => import('pages/ChangePassword'));


const appRoutes = [
  {
    path: RoutesPaths.App.LandingPage,
    name: 'home',
    icon: DashboardIcon,
    Component: LandingPage,
    includeLayout: true,
    isPublic: true,
    hasDashboardLink: true,
  },
  {
    path: RoutesPaths.App.About,
    name: 'about',
    icon: DashboardIcon,
    Component: AboutPage,
    includeLayout: true,
    isPublic: true,
    hasDashboardLink: true,
  },
  {
    path: RoutesPaths.App.TermsAndConditions,
    name: 'termsAndConditions',
    icon: DashboardIcon,
    Component: TermsAndConditionsPage,
    includeLayout: true,
    isPublic: true,
    hasDashboardLink: false,
  },
  {
    path: RoutesPaths.App.ContactUs,
    name: 'connect',
    icon: DashboardIcon,
    Component: ContactUsPage,
    includeLayout: true,
    isPublic: true,
    hasDashboardLink: true,
  },
  {
    path: RoutesPaths.App.Signup,
    name: 'signUp',
    icon: DashboardIcon,
    Component: Register,
    includeLayout: true,
    isPublic: true,
    hasDashboardLink: false,
  },
  {
    path: RoutesPaths.App.ForgetPassword,
    name: 'forgetPassword',
    icon: DashboardIcon,
    Component: ForgetPassword,
    includeLayout: true,
    isPublic: true,
    hasDashboardLink: false,
  },
  {
    path: RoutesPaths.App.ResetPassword,
    name: 'resetPassword',
    icon: DashboardIcon,
    Component: ResetPassword,
    includeLayout: true,
    isPublic: true,
    hasDashboardLink: false,
  },
  {
    path: RoutesPaths.App.ChangePassword,
    name: 'changePassword',
    icon: VpnKey,
    Component: ChangePasswordPage,
    includeLayout: true,
    isPublic: false,
    hasDashboardLink: false,
  },

  {
    path: RoutesPaths.App.NotFound,
    name: 'Not Found',
    icon: DashboardIcon,
    Component: NotFoundPage,
    includeLayout: false,
    isPublic: true,
    hasDashboardLink: false,
  },
];

export default appRoutes;
